"use server";

import { redirect } from "next/navigation";
import { createClient } from "@/lib/supabase/server";

export type AuthResult = {
  error?: string;
  needsConfirmation?: boolean;
};

function mapAuthError(message: string) {
  const lower = message.toLowerCase();
  if (lower.includes("invalid login")) {
    return "E-Mail oder Passwort ist falsch.";
  }
  if (lower.includes("already registered") || lower.includes("already been registered")) {
    return "Für diese E-Mail gibt es schon ein Konto.";
  }
  if (lower.includes("password")) {
    return "Das Passwort muss mindestens 6 Zeichen haben.";
  }
  if (lower.includes("email")) {
    return "Bitte eine gültige E-Mail-Adresse angeben.";
  }
  if (lower.includes("supabase_url") || lower.includes("fehlt")) {
    return "Supabase ist noch nicht konfiguriert. Trage URL und Anon-Key in .env.local ein.";
  }
  return "Anmeldung fehlgeschlagen. Prüfe die Zugangsdaten und versuche es erneut.";
}

export async function signIn(_prev: AuthResult, formData: FormData): Promise<AuthResult> {
  const email = String(formData.get("email") ?? "").trim();
  const password = String(formData.get("password") ?? "");

  try {
    const supabase = await createClient();
    const { error } = await supabase.auth.signInWithPassword({ email, password });
    if (error) return { error: mapAuthError(error.message) };
  } catch (error) {
    return {
      error: mapAuthError(error instanceof Error ? error.message : ""),
    };
  }

  return {};
}

export async function signUp(_prev: AuthResult, formData: FormData): Promise<AuthResult> {
  const email = String(formData.get("email") ?? "").trim();
  const password = String(formData.get("password") ?? "");

  try {
    const supabase = await createClient();
    const { data, error } = await supabase.auth.signUp({ email, password });
    if (error) return { error: mapAuthError(error.message) };
    if (!data.session) {
      return { needsConfirmation: true };
    }
  } catch (error) {
    return {
      error: mapAuthError(error instanceof Error ? error.message : ""),
    };
  }

  return {};
}

export async function signOut() {
  const supabase = await createClient();
  await supabase.auth.signOut();
  redirect("/");
}
